import { ReactNode, FC } from 'react'
import s from './SectionCarousel.module.sass'

import { Carousel } from '@shared/ui/Layout/Carousel'
import { SectionTitleSkeleton } from '@shared/ui/Layout/SectionTitle'
import { BlockBoundary } from '../../../lib/components/BlockBoundary'

interface Props {
  children?: ReactNode[]
  className?: string
  borderRadius?: string
}

const Skeleton: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  children,
  className = '',
  borderRadius = '16px 16px 0 0',
  ...props
}) => {
  return (
    <BlockBoundary>
      <div className={`${s.container} ${className}`} {...props}>
        <Carousel>
          <div className={s.header}>
            <SectionTitleSkeleton />
          </div>
          {children ? (
            <Carousel.Slider className={s.slider} style={{ borderRadius: borderRadius }}>
              {children}
            </Carousel.Slider>
          ) : (
            <Carousel.Slider className={s.slider} style={{ borderRadius: borderRadius }}>
              <div></div>
              <div></div>
            </Carousel.Slider>
          )}
        </Carousel>
      </div>
    </BlockBoundary>
  )
}

export default Skeleton
